export function clamp(n, a, b) {
  return Math.max(a, Math.min(b, Number(n || 0)));
}
